var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowupBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "640px",
    height: "640px",
    viewBox: "0 -80 640 640",
    enableBackground: "new 0 -80 640 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.073,5.753c0,0,152.92,152.921,193.738,193.739c5.476,5.475,5.476,14.353,0,19.828 c-13.19,13.191-36.38,36.38-49.57,49.571c-5.476,5.476-14.353,5.476-19.829,0l-124.339-124.34v358.939 c0,7.744-6.277,14.021-14.02,14.021c-18.656,0-51.45,0-70.105,0c-7.744,0-14.021-6.276-14.021-14.021V144.552l-124.339,124.34 c-5.476,5.476-14.353,5.476-19.828,0c-13.192-13.191-36.38-36.38-49.572-49.571c-5.475-5.475-5.475-14.353,0-19.828L263.918,12.764 c0,0,30.05-30.062,46.148-46.167c5.475-5.476,14.351-5.479,19.827-0.004l39.178,39.161H369.073L369.073,5.753z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowupBlack);
export default __webpack_public_path__ + "static/media/icon-arrowup-black.70aaac441e91f6469076e6b5b5ea76d5.svg";
export { ForwardRef as ReactComponent };